import React from 'react';
import { ToggleButton } from '@leverege/ui-elements';
import i18n from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.Bold');
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.Bold',
  handles: () => true,
  layout: {
    sort: 'A'
  },
  customComponent: props => {
    const {
      context: {
        editor
      }
    } = props;
    return /*#__PURE__*/_jsx(ToggleButton, {
      title: t('title'),
      variant: "customTextBold|customText",
      disabled: !editor.can().chain().focus().toggleBold().run() || editor.isActive('code'),
      value: editor.isActive('bold'),
      onChange: () => editor.chain().focus().toggleBold().run(),
      icon: tIcon('icon', 'fa fa-bold')
    });
  }
};